import withReducer from '../../store/withReducer'
import SsoLogin from './container'
import reducer from './module'

export default withReducer('ssoLogin', reducer)(SsoLogin)



// WEBPACK FOOTER //
// ./src/legacy/pages/SsoLogin/index.js